import React from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import InternationalPhoneInput from '../../../common/InternationalPhoneInput'
import CondominiumLocationFields from '../../../common/CondominiumLocationFields'
import IdentificationInput from '../IdentificationInput'
import ProfilePhotoPicker from '../ProfilePhotoPicker'
import FieldError from '../FieldError'
import { PROVIDER_TYPES } from '../../marketplaceConstants'

const PERSON_PREFIXES = ['V', 'E']
const RIF_PREFIXES = ['J', 'G', 'V', 'E', 'P']

const TextField = ({ label, name, form, errors, onChange, placeholder, md = 6 }) => (
  <Col md={md}>
    <FormGroup>
      <Label for={name}>
        {label}
        <span className="text-danger ml-1">*</span>
      </Label>
      <Input
        id={name}
        value={form[name]}
        placeholder={placeholder}
        invalid={Boolean(errors[name])}
        onChange={({ target }) => onChange(name, target.value)}
      />
      <FieldError error={errors[name]} />
    </FormGroup>
  </Col>
)

const ProviderDataStep = ({ form, photo, onPhotoChange, errors, onChange }) => {
  const isCompany = form.type === PROVIDER_TYPES.company
  const fieldProps = { form, errors, onChange }

  return (
    <>
      <ProfilePhotoPicker file={photo} onChange={onPhotoChange} isCompany={isCompany} error={errors.photo} />

      {isCompany ? (
        <>
          <h6 className="text-uppercase text-600 fs--1 mb-3">Información de la empresa</h6>
          <Row form>
            <TextField label="Razón social" name="legal_name" placeholder="Ej: Refrigeración Polar C.A." {...fieldProps} />
            <TextField label="Nombre comercial" name="trade_name" placeholder="Ej: FrioPolar" {...fieldProps} />
            <Col md={6}>
              <FormGroup>
                <Label>
                  RIF
                  <span className="text-danger ml-1">*</span>
                </Label>
                <IdentificationInput
                  value={form.rif}
                  prefixes={RIF_PREFIXES}
                  placeholder="401234567"
                  invalid={Boolean(errors.rif)}
                  onChange={(value) => onChange('rif', value)}
                />
                <FieldError error={errors.rif} />
              </FormGroup>
            </Col>
            <TextField label="Dirección del local u oficina" name="address" placeholder="Av., edificio, local" {...fieldProps} />
          </Row>

          <h6 className="text-uppercase text-600 fs--1 mb-3 mt-2">Representante legal</h6>
          <Row form>
            <TextField label="Nombre y apellido" name="legal_rep_name" md={12} {...fieldProps} />
            <Col md={6}>
              <FormGroup>
                <Label>
                  Cédula
                  <span className="text-danger ml-1">*</span>
                </Label>
                <IdentificationInput
                  value={form.legal_rep_dni}
                  prefixes={PERSON_PREFIXES}
                  placeholder="12345678"
                  invalid={Boolean(errors.legal_rep_dni)}
                  onChange={(value) => onChange('legal_rep_dni', value)}
                />
                <FieldError error={errors.legal_rep_dni} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="legal_rep_phone">
                  Teléfono
                  <span className="text-danger ml-1">*</span>
                </Label>
                <InternationalPhoneInput
                  id="legal_rep_phone"
                  placeholder="Número de teléfono"
                  invalid={Boolean(errors.legal_rep_phone)}
                  value={form.legal_rep_phone || undefined}
                  onChange={(value) => onChange('legal_rep_phone', value || '')}
                />
                <FieldError error={errors.legal_rep_phone} />
              </FormGroup>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <h6 className="text-uppercase text-600 fs--1 mb-3">Información personal</h6>
          <Row form>
            <TextField label="Nombre" name="first_name" {...fieldProps} />
            <TextField label="Apellido" name="last_name" {...fieldProps} />
            <Col md={6}>
              <FormGroup>
                <Label>
                  Cédula de identidad
                  <span className="text-danger ml-1">*</span>
                </Label>
                <IdentificationInput
                  value={form.dni}
                  prefixes={PERSON_PREFIXES}
                  placeholder="12345678"
                  invalid={Boolean(errors.dni)}
                  onChange={(value) => onChange('dni', value)}
                />
                <FieldError error={errors.dni} />
              </FormGroup>
            </Col>
          </Row>
          <CondominiumLocationFields
            required
            state={form.state}
            city={form.city}
            onStateChange={(value) => {
              onChange('state', value)
              onChange('city', '')
            }}
            onCityChange={(value) => onChange('city', value)}
            stateError={errors.state}
            cityError={errors.city}
          />
        </>
      )}
    </>
  )
}

export default ProviderDataStep
